import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { dataFormCertificates, } from "./resources/certificatesEditorDTOS";
import { CertificateEditorView } from "./ui/certificateEditorView";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import showToast from "../../services/toast";
import { useApiCreateCertificate } from "../../fnx/certificate/postCertificate";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { certificateTemplateOneClearData, createCertificateClearData, putCertTemplateClearData, } from "../../store/certificates/actions";
import { showErrorToast } from "../../fnx/showError";
import useFnCreateCertificate from "./helpers/createCertificate";
import { GetOneCertTemplate } from "../../fnx/certificate/getOneCertTemplate";
import useFnUpdateCertificate from "./helpers/updateCertificate";
import { useApiUpdateCertificate } from "../../fnx/certificate/putCertTemplate";
export var CertificatesEditorPage = function () {
    var t = useTranslation().t;
    var certificateId = useParams();
    var isUpdate = useParams();
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = useState(false), triggerCreate = _a[0], setTriggerCreate = _a[1];
    var _b = useState(false), triggerUpdate = _b[0], setTriggerUpdate = _b[1];
    var _c = useState(false), triggerGetCert = _c[0], setTriggerGetCert = _c[1];
    var _d = useState(""), certificateHtml = _d[0], setCertificateHtml = _d[1];
    var mergeFieldsData = useState(function () {
        var data = sessionStorage.getItem("mergeFieldsData");
        return data ? JSON.parse(data) : [];
    })[0];
    var _e = useState(dataFormCertificates), dataCertificate = _e[0], setDataCertificate = _e[1];
    var _f = useState(false), openDrawer = _f[0], setOpenDrawer = _f[1];
    var _g = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _g[0], setSeeToast = _g[1];
    ///CALL HELPERS
    var _h = useFnCreateCertificate(), createCertificate = _h.createCertificate, bodyRequest = _h.bodyRequest;
    var _j = useFnUpdateCertificate(), updateCertificate = _j.updateCertificate, updateBodyRequest = _j.updateBodyRequest;
    ///CALL APIS
    var _k = useApiCreateCertificate(triggerCreate, bodyRequest), loadingCreateCertificate = _k.loadingCreateCertificate, responseCreateCertificate = _k.responseCreateCertificate, errorCreateCertificate = _k.errorCreateCertificate;
    var _l = GetOneCertTemplate(triggerGetCert, certificateId.certificateId || ""), loadingOneCertTemplate = _l.loadingOneCertTemplate, responseOneCertTemplate = _l.responseOneCertTemplate, errorOneCertTemplate = _l.errorOneCertTemplate;
    var _m = useApiUpdateCertificate(triggerUpdate, certificateId.certificateId || "", updateBodyRequest), loadingPutCertificate = _m.loadingPutCertificate, responsePutCertificate = _m.responsePutCertificate, errorPutCertificate = _m.errorPutCertificate;
    useEffect(function () {
        setCertificateHtml("");
    }, []);
    useEffect(function () {
        if (certificateId.certificateId) {
            setTriggerGetCert(true);
        }
    }, [certificateId]);
    useEffect(function () {
        if (responseCreateCertificate === null || responseCreateCertificate === void 0 ? void 0 : responseCreateCertificate.data) {
            dispatch(createCertificateClearData());
            navigate("/certificates/true");
        }
    }, [responseCreateCertificate]);
    useEffect(function () {
        if (responsePutCertificate === null || responsePutCertificate === void 0 ? void 0 : responsePutCertificate.data) {
            dispatch(putCertTemplateClearData());
            setOpenDrawer(false);
            navigate("/certificates/false/true");
        }
    }, [responsePutCertificate]);
    useEffect(function () {
        if (errorCreateCertificate) {
            showErrorToast(errorCreateCertificate, setSeeToast, t);
            setTriggerCreate(false);
            dispatch(certificateTemplateOneClearData());
        }
    }, [errorCreateCertificate]);
    useEffect(function () {
        if (errorPutCertificate) {
            showErrorToast(errorPutCertificate, setSeeToast, t);
            setTriggerUpdate(false);
            dispatch(putCertTemplateClearData());
        }
    }, [errorPutCertificate]);
    useEffect(function () {
        if (errorOneCertTemplate) {
            showErrorToast(errorOneCertTemplate, setSeeToast, t);
        }
    }, [errorOneCertTemplate]);
    useEffect(function () {
        var _a, _b, _c;
        if (responseOneCertTemplate === null || responseOneCertTemplate === void 0 ? void 0 : responseOneCertTemplate.data) {
            setCertificateHtml(responseOneCertTemplate.data.html);
            var type = responseOneCertTemplate.data.type;
            var formattedValue = type
                ? type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()
                : "";
            setDataCertificate({
                fileName: (_a = responseOneCertTemplate === null || responseOneCertTemplate === void 0 ? void 0 : responseOneCertTemplate.data) === null || _a === void 0 ? void 0 : _a.title,
                productName: ((_c = (_b = responseOneCertTemplate === null || responseOneCertTemplate === void 0 ? void 0 : responseOneCertTemplate.data) === null || _b === void 0 ? void 0 : _b.projects[0]) === null || _c === void 0 ? void 0 : _c.description) || "",
                typeFile: {
                    id: type,
                    name: formattedValue,
                },
            });
        }
        dispatch(certificateTemplateOneClearData());
    }, [responseOneCertTemplate]);
    var onSaveCertificate = function (data, fileName, typeFile) {
        if (isUpdate.isUpdate === "true") {
            updateCertificate(data, fileName, typeFile, setTriggerUpdate);
        }
        else {
            createCertificate(data, fileName, typeFile, setTriggerCreate);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingCreateCertificate ||
                    loadingOneCertTemplate ||
                    loadingPutCertificate, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: t("certificatesEditor.loading-1") }), _jsx(CertificateEditorView, { dataCertificate: dataCertificate, onSaveCertificate: onSaveCertificate, openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, translate: t, navigate: navigate, certificateHtml: certificateHtml, mergeFieldsData: mergeFieldsData })] }));
};
